import Dataman from 'App/Dataman';
import { sortAsc } from 'App/utils/Helpers';
import { i18n } from 'App/plugins/i18n';

export async function loadActivitySpheres() {
  const { data } = await Dataman.DB.activitySpheres.getList({ itemsPerPage: 300, locale: i18n.locale });
  return data.sort(() => sortAsc('name'));
}

export default {
  loadActivitySpheres,
};
